import { useEntities, useEntity } from "@ui/hooks/serviceUtils";
import useDataManager, { DataManagerProps } from "@ui/hooks/useDataManager";
import { DateTime } from "luxon/src/luxon";
import { ISupplier } from "./useSupplier";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export interface ISupplierPortal {
  id: string;
  supplier?: ISupplier;
  date: DateTime; // UTC time string
  meal: string;
  count: number;
  groupId?: string;
  fields?: {
    locationCount?: Array<{
      masterDataId: string;
      location: string;
      count: number;
    }>;
    [key: string]: any;
  };
}

const key = "supplierportal";
const endpoint = "/api/supplierportal";

export const useSuppliersPortalQuery = (
  props: DataManagerProps<ISupplierPortal> = {},
) => useDataManager<ISupplierPortal>(key, `${endpoint}/query`, props);
export const useSuppliersPortal = () =>
  useEntities<ISupplierPortal>(key, endpoint);
export const useSupplierPortal = (
  id: string | undefined,
  toast: boolean = true,
) =>
  useEntity<ISupplierPortal>(
    key,
    endpoint,
    id,
    toast
      ? {
          add: "Supplier Portal added",
          update: "Supplier Portal updated",
          delete: "Supplier Portal deleted",
        }
      : undefined,
  );

export const useTodaySupplierMeals = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["today-supplier-meals", userId],
    queryFn: async () => {
      if (!userId) return [];
      const url = `${endpoint}/today/${userId}`;
      const { data } = await axios.get<any>(url);

      return data;
    },
    enabled: !!userId,
  });
};

export const useSupplierMealsSummary = (
  userId: string | undefined,
  startDate: DateTime | undefined,
  endDate: DateTime | undefined,
) => {
  const formattedStart = startDate?.toISODate() ?? "";
  const formattedEnd = endDate?.toISODate() ?? "";

  return useQuery({
    queryKey: ["summary", userId, formattedStart, formattedEnd],
    queryFn: async () => {
      if (!userId) return [];
      const url = `${endpoint}/summary/?userId=${userId}&startDate=${formattedStart}&endDate=${formattedEnd}`;
      const { data } = await axios.get<any>(url);

      return data;
    },
    enabled: Boolean(formattedStart && formattedEnd && userId),
  });
};
